import {Advert, AdvertType} from '#/Advert';
import {SearchOptions} from '#/Search';

export interface AdvertState {
    advert: Advert;
    adverts: Advert[];
    advertTypeItems: AdvertType[];
    pageNumber: number;
    searchOptions: SearchOptions;
    urlNextPage: null | string;
    typeFilter: AdvertType | null;
}

/**
 * Tableau des constantes pour les types d'annonces.
 */
export enum AdvertTypes {
    Assistance = 1,
    Project = 2,
    Outing = 3,
}

/**
 * Objets permettant gérer les icônes pour les types d'annonce.
 */
export const AdvertTypeItems: AdvertType[] = [];
AdvertTypeItems[AdvertTypes.Assistance] = {
    raw: AdvertTypes.Assistance,
    display: 'assistance',
    iconName: 'nv-save-nature',
    color: '#35c940',
};
AdvertTypeItems[AdvertTypes.Project] = {
    raw: AdvertTypes.Project,
    display: 'project',
    iconName: 'nv-lightbulb',
    color: '#3399ff',
};
AdvertTypeItems[AdvertTypes.Outing] = {
    raw: AdvertTypes.Outing,
    display: 'outing',
    iconName: 'us-calendar',
    color: '#f83367',
};

/**
 * Annonce vide pour réinitialiser.
 *
 * @type {Advert}
 */
export const emptyAdvert = (): Advert => {
    return {
        archivedAt: null,
        author: {
            id: 0,
            description: '',
            isAdmin: false,
            name: '',
            profileColor: '',
            profilePhoto: null,
            profileUrl: null,
        },
        availability: null,
        categories: [],
        content: '',
        createdAt: new Date(),
        endsAt: null,
        id: 0,
        isFavorite: false,
        isPublished: false,
        participantsLimit: null,
        period: {
            isDate: false,
            datesSelected: [],
            periodSelected: null,
        },
        publishedAt: null,
        startsAt: null,
        tags: [],
        title: '',
        type: {
            color: '',
            display: '',
            iconName: '',
            raw: 0,
        },
        updatedAt: new Date(),
    };
};

export const searchOptionsEmpty = (): SearchOptions => ({
    facets: {
        category: [],
        type: [],
    },
    fieldOpen: false,
    isSpecify: false,
    lastTerm: '',
    results: {
        count: 0,
        adverts: [],
    },
    suggests: [],
});

export const state: AdvertState = {
    advert: emptyAdvert(),
    adverts: [],
    advertTypeItems: [...AdvertTypeItems],
    pageNumber: 1,
    searchOptions: searchOptionsEmpty(),
    urlNextPage: null,
    typeFilter: null,
};


